import React from "react";

import { HubButton, HubContextMenu } from "../../components";

const shared = {
  icon: "Calendar",
};
export const CHART_RANGES = [
  { id: "12M", label: "1 Year", ...shared },
  { id: "1Q", label: "1 Quarter", ...shared },
  { id: "3M", label: "3 Months", ...shared },
  { id: "6W", label: "6 Weeks", ...shared },
];

const ChartRangeSlider = ({ value = "1Q", onChange = () => {} }) => {
  const onSelect = (selected) => {
    onChange(selected.id);
  };

  const label = CHART_RANGES.find((r) => r.id === value)?.label;
  const MenuButton = (
    <HubButton
      variant="tinyButton"
      label={label ? `Period: ${label}` : "Period"}
      color="neutral"
    />
  );

  return (
    <HubContextMenu
      id="ChartRange"
      loading={false}
      menuButton={MenuButton}
      menuItems={CHART_RANGES}
      onSelect={onSelect}
      IconButtonProps={{ sx: { padding: "2px" } }}
      HubIconProps={{ size: 12 }}
    />
  );
};

export default ChartRangeSlider;
